<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row loader" v-if="loading">
      <div class="col align-self-center text-center ">
        <square-loader />
      </div>
    </div>
    <div v-if="!loading">
      <div class="row mt-4">
        <h4 class="mt-4 col-12">Profil de {{user.username}}</h4>
      </div>
      <div class="row mt-4">
        <div class="col-md-4 text-center">
          <img v-bind:src="user.picture" width="256" v-if="user.picture"/>
          <img src="../../assets/default-profile.png" v-else width="256"/>
          <br />
        </div>
        <div class="col-md-4 text-center">
          <button class="btn btn-link" v-on:click="addToFriends" v-if="!isFriend">
            <img src="/static/user-plus.svg"/>Ajouter {{user.username}} à mes amis</button>
          <button class="btn btn-link" v-on:click="removeFromFriends" v-else>
            <img src="/static/user-times.svg"/>Supprimer de mes amis</button>
        </div>
      </div>
      <div lass="row mt-4" v-if="isPremiumOrAdmin && games.length > 0">
       <div class="col-12">
          <ProfileCharts v-bind:games="games"/>
        </div>
     </div>
      <div class="row mt-4">
        <div class="col-12 col-md-4 player-list">
          <h4>Amis de {{user.username}}</h4>
          <ul class="list-group list-group-flush" v-if="user.friends">
            <li v-for="player in user.friends" v-bind:key="player.userId" class="list-group-item">
              <Player v-bind:username="player.username"
              v-bind:userId="player.userId"
              v-bind:picture="player.picture"/>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-8">
          <user-game-list v-if="games.length > 0"
            v-bind:games="games"/>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import LoggedUser from '../LoggedUser.vue';
import SquareLoader from '../SquareLoader.vue';
import BottomNav from '../BottomNav.vue';
import UserGameList from './UserGameList.vue';
import Player from '../Player.vue';
import ProfileCharts from './ProfileCharts.vue';

export default {
  name: 'ProfileView',
  components: { LoggedUser, BottomNav, SquareLoader, UserGameList, Player, ProfileCharts },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      user: undefined,
      me: iam.getConnectedUser(),
      isPremiumOrAdmin: iam.isPremiumOrAdmin(),
      games: [],
    };
  },
  computed: {
    isFriend() {
      return this.me.friends && this.me.friends.find(f => f.userId === this.userId);
    },
  },
  async created() {
    this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/users/${this.userId}`).then((response) => {
      this.user = response.data;
      this.loading = false;
    });
    this.games = await this.getGames();
  },
  methods: {
    addToFriends() {
      if (!this.me.friends) {
        this.me.friends = [];
      }
      this.me.friends.push({
        userId: this.userId,
        username: this.user.username,
        picture: this.user.picture,
      });
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/friends`, this.me.friends)
        .then(() => {
          iam.setConnectedUser(this.me);
        });
    },
    removeFromFriends() {
      this.me.friends = this.me.friends.filter(f => f.userId !== this.userId);
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/friends`, this.me.friends)
        .then(() => {
          iam.setConnectedUser(this.me);
        });
    },
    async getGames() {
      const url = this.userId
        ? `${import.meta.env.VITE_LCT_API_URL}/ended-games-players/${this.userId}`
        : `${import.meta.env.VITE_LCT_API_URL}/ended-games-players/me`;
      return this.$http.get(url).then(response => response
        .data.sort((a, b) => a.createdAt - b.createdAt));
    },
  },
};
</script>

<style scoped>
  .btn-link{
    color: #CE0F69;
  }
  .player-list{
    z-index: 1;
  }
  .player-list ul{
    list-style-type: none;
    margin: 4px 0 0 0;
  }
  .player-list ul .list-group-item {
    padding-top: 4px;
    padding-bottom: 4px;
  }
  div.loader {
    min-height: 100vh;
  }
  img{
    width: 40px;
    margin-right: 4px;
  }
</style>
